import { render, staticRenderFns } from "./RDWSD.vue?vue&type=template&id=fdbd5bc8&scoped=true"
import script from "./RDWSD.vue?vue&type=script&lang=js"
export * from "./RDWSD.vue?vue&type=script&lang=js"
import style0 from "./RDWSD.vue?vue&type=style&index=0&id=fdbd5bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbd5bc8",
  null
  
)

export default component.exports